import { Order } from '../../types/orders';
import { OperationLineItem, AuthorizationGroup } from '../types';
import { getSignificationAuthorizationGroupsForRefund } from '../helpers';

export enum ActionTypes {
    Open = '[orders/refund] OPEN',
    Dismiss = '[orders/refund] DISMISS',
    InvokeRequest = '[orders/refund] START',
    SuccessResponse = '[orders/refund] SUCCESS',
    ErrorResponse = '[orders/refund] ERROR',
}

export interface Open {
    type: ActionTypes.Open;
    payload: {
        order: Order;
        authorizationGroup: AuthorizationGroup | undefined;
    };
}

export function openRefund(order: Order): Open {
    const groups = getSignificationAuthorizationGroupsForRefund(order);
    return {
        type: ActionTypes.Open,
        payload: {
            order,
            authorizationGroup: groups.length === 1 ? groups[0] : undefined,
        },
    };
}

export function setGroup(order: Order, authorizationGroup: AuthorizationGroup): Open {
    return {
        type: ActionTypes.Open,
        payload: {
            order,
            authorizationGroup: authorizationGroup,
        },
    };
}

export interface Dismiss {
    type: ActionTypes.Dismiss;
    payload: {};
}

export function dismissModal(): Dismiss {
    return {
        type: ActionTypes.Dismiss,
        payload: {},
    };
}

export interface Refund {
    type: ActionTypes.InvokeRequest;
    payload: {
        accountId: string;
        order: Order;
        items: OperationLineItem[];
        authorizationId?: string;
    };
}

export function refundItems(accountId: string, order: Order, items: OperationLineItem[], authorizationId: string | undefined): Refund {
    return {
        type: ActionTypes.InvokeRequest,
        payload: {
            accountId,
            order,
            items,
            authorizationId,
        },
    };
}

export interface RefundSuccess {
    type: ActionTypes.SuccessResponse;
    meta: {
        cause: Refund;
    };
}

export interface RefundError {
    type: ActionTypes.ErrorResponse;
    payload: {
        code: string;
        message: string;
        errors: any;
    };
    meta: {
        cause: Refund;
    };
}

export type OperationResult = RefundSuccess | RefundError;

export type Actions = Open | Dismiss | Refund | RefundSuccess | RefundError;
